import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
// import {PulseLoader} from 'halogen'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

// REDUX ACTIONS
import {withRouter, Link} from "react-router-dom";
import * as stationActions from '../../../../actions/stations'

/*** REACT TOOLBOX ***/
import List from 'react-toolbox/lib/list/List'
import ListItem from 'react-toolbox/lib/list/ListItem'
import CheckBox from 'react-toolbox/lib/checkbox/Checkbox'
import Button from 'react-toolbox/lib/button/Button'
import IconButton from 'react-toolbox/lib/button/IconButton'
import ListSubHeader from 'react-toolbox/lib/list/ListSubHeader'
import ListDivider from 'react-toolbox/lib/list/ListDivider'

import {TopDashboard} from "./topCharts";

import './StationList.css'

const tableNames = ["Identifier", "Current Node", "Status", "Last Activity"];
const order_icons = ["unfold_more", "expand_less", "expand_more"];
const orderStatus = ['active', 'idle', 'disabled'];

let order;

const MySwal = withReactContent(Swal);

/*
 estation id, current node, last activity, status ( active, idle, depracated) , graph data buton,  depracte button
 */
const createNodeInf = (entity) => {
    let last = new Date(entity.lastActivity.value);
    let diff = new Date() - last;
    let classState = 'timeKo';

    if (diff < 1200000)
        classState = 'timeOk';
    else if (diff < 86400000)
        classState = 'timeWarn';

    return (<div className={'stationListItem'}>
        <span className={'stationListItemInfo'}> {entity.id}</span>
        <span className={'stationListItemInfo small'}> {entity.currentNode.value.node_id}</span>
        <span className={'stationListItemInfo small ' + entity.status.value}> {entity.status.value.toUpperCase()}</span>
        <span className={`stationListItemInfo small ${classState}`}> {entity.lastActivity.value ? new Date(entity.lastActivity.value).toLocaleString() : null}</span>
    </div>)
};

const handleChangeStationStatus = (id, station, updateStation) => {
    let body = {
        currentNode: {
            node_id: station.currentNode.value.node_id,
            from: station.currentNode.value.from
            },
        status: station.status.value === 'active' ? 'idle' : 'active'
    };

    updateStation(id, body, (response, err) => {
        if(err)
            MySwal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                title: `Error: ${response.status}`,
                text: response.error,
                type: 'error',
            });
    });
};

const handleRenderSensors = (handleCheckBoxChange, updateStation) => {

    return order.map((entity, key) => {
        return (
            <ListItem
                key={key}
                caption={entity.id}
                itemContent={createNodeInf(entity)}
                className={entity.checked ? 'selected' : ''}
                leftActions={[
                    <CheckBox
                        key={key}
                        className={'nodeListCheckBox'}
                        checked={entity.checked}
                    />
                ]}
                rightActions={[
                    <Link to={`/admin/stations/details/${entity.id}`} key={key}>
                        <IconButton
                            key={key}
                            icon='info'
                            primary
                        />
                    </Link>,
                    <Link to={`/stations/map/${entity.id}`} key={`${key}_2`}>
                        <IconButton
                            key={key}
                            icon="location_on"
                            primary
                            disabled={entity.status.value === 'disabled'}
                        />
                    </Link>,
                    <IconButton
                        key={key}
                        icon={entity.status.value === 'active' ? 'wifi_off' : 'wifi_on'}
                        className={entity.status.value === 'active' ? '' : 'wifi_correction'}
                        primary
                        disabled={entity.status.value === 'disabled'}
                        onClick={() => handleChangeStationStatus(entity.id, entity, updateStation)}
                    />,
                    <Link to={`/stations/chart/${entity.id}`} key={`${key}_3`}>
                        <IconButton
                            key={key}
                            icon="insert_chart"
                            primary
                        />
                    </Link>
                ]}
                onClick={() => handleCheckBoxChange(key)}

            />
        )
    })
};

const StationList = props => {

    order = [];

    if (props.order.active) {

        let aux = [];

        aux = aux.concat(props.stations);

        let index = props.order.status.indexOf(1);

        if (index === -1)
            index = props.order.status.indexOf(2) + 4;

        switch (index % 4) {
            case 0:
                order = aux.sort((x, y) => {
                    return ('' + x.id).localeCompare(y.id);
                });
                break;

            case 1:
                order = aux.sort((x, y) => {
                    return ('' + x.currentNode.value.node_id).localeCompare(y.currentNode.value.node_id);
                });
                break;

            case 2:
                orderStatus.forEach(value => {
                    let tmp = aux.filter(element => {
                        return element.status.value === value
                    });
                    order = order.concat(tmp);
                });
                break;

            case 3:
                order = aux.sort((x, y) => {
                    let timex = new Date(x.lastActivity.value);
                    let timey = new Date(y.lastActivity.value);

                    if(isNaN(timex.getTime()))
                        return 1;
                    else if(isNaN(timey.getTime()))
                        return -1;
                    else if(timex < timey)
                        return -1;
                    else if(timex > timey)
                        return 1;
                    else
                        return 0;
                });
                break;

            default:
                break;
        }

        if (index > 3)
            order = order.reverse();

    } else {

        order = order.concat(props.stations);

    }

    order = order.slice(props.page, props.page + 20);


    let checkList = "/";

    props.stations.forEach(entity => {
        if (entity.checked)
            checkList += entity.id + ',';
    });

    return (
        <div>

            <TopDashboard stations={props.stations} content={props.content}/>

            <div className={'row'}>
                <div className=" col-xs-12 nodeContent">
                    <div className="nodeListContainer">
                        <div className="listHeader">
                            <ListSubHeader className="listSubheader" caption="Current Stations"/>

                            <Link to='/stations/new'>
                                <IconButton accent
                                            className="listHeaderButton"
                                            icon="add"/>
                            </Link>

                            {checkList.length > 1 &&
                            <Link to={`/stations/chart${checkList}`}>
                                <IconButton
                                    key={'explore'}
                                    icon="insert_chart"
                                    primary
                                    className="listHeaderButton"
                                />
                            </Link>}
                        </div>
                        <div className={'stationListFieldContainer'}>
                            {tableNames.map((field, key) => {
                                return (<span key={key} className={'stationListField'}> {field} <IconButton
                                    key={key}
                                    icon={order_icons[props.order.status[key]]}
                                    primary
                                    onClick={() => props.handleOrder(key)}
                                /></span>)
                            })}
                        </div>
                        <ListDivider/>
                        <List selectable ripple className={'nodeList'}>
                            {props.content ?
                                handleRenderSensors(props.handleCheckBoxChange, props.stationActions.updateStation)
                                :
                                null
                                // <PulseLoader className="LoadTable"
                                //              color="#0A2A59"
                                //              size={"20px"}
                                //              margin={"4px"}/>}
                            }
                            {props.count > 20 && <ListDivider/>}
                            {props.count > 20 && <ListItem key={'Paginator'}
                                                           rightActions={[
                                                               <IconButton
                                                                   key={'Paginator'}
                                                                   icon='keyboard_arrow_left'
                                                                   primary
                                                                   onClick={() => props.handleSensorsPage("previous")}
                                                               />,
                                                               <IconButton
                                                                   key={'Paginator'}
                                                                   icon="keyboard_arrow_right"
                                                                   primary
                                                                   onClick={() => props.handleSensorsPage("next")}
                                                               />
                                                           ]}
                            />}
                        </List>
                    </div>
                    {checkList.length > 1 &&
                    <div className={'bottomRigthFixedButton dataExplorerButton'}>
                        <Link to={`/stations/chart${checkList}`}>
                            <Button label={'Data Explorer'} primary raised/>
                        </Link>
                    </div>}
                </div>
            </div>
        </div>
    );
};

const sensorListDispatchToProps = (dispatch) => {
    return {
        stationActions: bindActionCreators(stationActions, dispatch)
    }
};


export default withRouter(connect(null, sensorListDispatchToProps)(StationList))



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminStations/StationList/StationList.js